interface PasswordConfig {
	minlength?: number;
	lowercase?: boolean;
	uppercase?: boolean;
	numbers?: boolean;
	symbols?: boolean;
	specialCharacters?: boolean;
}

export function hasMinLength(password: string, config: PasswordConfig): boolean {
	// @ts-expect-error TS2322
	return password && password.length >= config.minlength;
}

export function hasNumbers(password: string): boolean {
	const numberRegex = /[0-9]/g;

	// @ts-expect-error TS2322
	return password && !!password.match(numberRegex);
}

export function hasSymbols(password: string): boolean {
	const symbolRegex = /[\^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`=+]/g;

	// @ts-expect-error TS2322
	return password && !!password.match(symbolRegex);
}

export function hasLowerCase(password: string): boolean {
	const lowerCasePasswordRegex = /[a-z]/g;

	// @ts-expect-error TS2322
	return password && !!password.match(lowerCasePasswordRegex);
}

export function hasUpperCase(password: string): boolean {
	const upperCasePasswordRegex = /[A-Z]/g;

	// @ts-expect-error TS2322
	return password && !!password.match(upperCasePasswordRegex);
}
